import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { apiClient } from "../../../api/httpClient";
import { getPgHomeVariantConfig, IU_HOME_VARIANT } from "../pgHomeConfig";
import { useHomeDataBase } from "./useHomeDataBase";

export const PG_HOME_PAGE_SIZE = 5;

/**
 * Internal-user home dashboard data (no JSX).
 * @param {'internalUser'|'admin'} variant
 */
export function useIuHomeData(variant = IU_HOME_VARIANT.internalUser) {
  const cfg = getPgHomeVariantConfig(variant);
  const location = useLocation();
  const auth = useSelector((state) => state.auth);
  const internalUserId = useSelector((state) => state.auth.role_id);

  const [userFeatures, setUserFeatures] = useState([]);
  const [unassignedBonds, setUnassignedBonds] = useState([]);
  const [loadingUnassigned, setLoadingUnassigned] = useState(false);

  const homeData = useHomeDataBase({
    userId: auth?.user?.id,
    pgId: null,
    enabled: true,
    appendIndemnityFormFields: (form, { userId }) => {
      const authPgId = auth?.pg_id;
      if (authPgId) form.append("professional_guardian_id", String(authPgId));
      if (userId) form.append("requester_id", String(userId));
    },
  });

  useEffect(() => {
    const fetchInternalUser = async () => {
      try {
        if (!internalUserId) {
          setUserFeatures([]);
          return;
        }
        const response = await apiClient(`/get-internal-user/${internalUserId}`, "GET");
        setUserFeatures(Array.isArray(response?.features) ? response.features : []);
      } catch (error) {
        console.error("Error fetching internal user:", error);
        setUserFeatures([]);
      }
    };
    fetchInternalUser();
  }, [internalUserId]);

  useEffect(() => {
    const loadUnassignedBonds = async () => {
      try {
        setLoadingUnassigned(true);
        const data = await apiClient("/unassigned-paralegal-bonds", "GET");
        setUnassignedBonds(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error("Failed to load unassigned bonds", e);
        setUnassignedBonds([]);
      } finally {
        setLoadingUnassigned(false);
      }
    };
    loadUnassignedBonds();
  }, [location.pathname]);

  return {
    cfg,
    variant,
    userFeatures,
    drafts: homeData.drafts,
    activity: homeData.activity,
    indemnity: homeData.indemnity,
    assignment: {
      bonds: unassignedBonds,
      loading: loadingUnassigned,
    },
    dialogs: homeData.dialogs,
    compliance: homeData.compliance,
  };
}
